module.exports = __webpack_public_path__ + "static/media/bg.9e3e5682.png";